import { StandardEvents } from '@shopify/events';

export class PawlSizeConfirmation extends HTMLElement {
  connectedCallback() {
    this._abort?.abort();
    this._abort = new AbortController();
    this._generation = 0;
    this._pending = false;
    this._available = this.dataset.available === 'true';
    this._checkbox = this.querySelector('[data-size-confirm-checkbox]');
    this._summary = this.querySelector('[data-size-summary]');
    this._status = this.querySelector('[data-size-confirm-status]');
    this._productForm = this.closest('product-form-component');
    this._accelerated = this._productForm?.querySelector('[data-size-accelerated]');
    const scope = this.closest('.shopify-section, dialog, product-card');
    const signal = this._abort.signal;
    if (this._checkbox) this._checkbox.checked = false;
    this._render();
    this._checkbox?.addEventListener('change', () => {
      if (this._pending || !this._available) this._checkbox.checked = false;
      this._render();
    }, { signal });
    scope?.addEventListener(StandardEvents.productSelect, event => this._selectionChanged(event), { signal });
  }

  disconnectedCallback() {
    this._abort?.abort();
    this._generation += 1;
  }

  _render(error = false) {
    this._accelerated = this._productForm?.querySelector('[data-size-accelerated]');
    const confirmed = Boolean(this._checkbox?.checked && !this._pending && this._available);
    if (this._accelerated) {
      this._accelerated.hidden = !confirmed;
      this._accelerated.inert = !confirmed;
    }
    this.setAttribute('aria-busy', String(this._pending));
    if (this._status) {
      this._status.textContent = this._pending ? this.dataset.pendingText : error ? this.dataset.errorText : this.dataset.readyText;
    }
  }

  async _selectionChanged(event) {
    const sourceCard = event.target?.closest?.('product-card');
    if (sourceCard && !sourceCard.contains(this)) return;
    const generation = ++this._generation;
    this._pending = true;
    if (this._checkbox) this._checkbox.checked = false;
    this._render();
    try {
      const { detail } = await event.promise;
      if (!this.isConnected || generation !== this._generation) return;
      const productId = detail?.newProduct?.id || detail?.productId;
      if (productId && String(productId) !== this.dataset.productId && !detail?.newProduct) {
        this._pending = false;
        this._render();
        return;
      }
      const fresh = detail?.html?.querySelector('pawl-size-confirmation');
      const summary = fresh?.querySelector('[data-size-summary]');
      this._available = Boolean(summary && detail?.resource?.id && detail.resource.available !== false);
      if (summary && this._summary) this._summary.replaceChildren(...[...summary.childNodes].map(node => node.cloneNode(true)));
      if (detail?.newProduct?.id) this.dataset.productId = String(detail.newProduct.id);
      this._pending = false;
      this._render(!summary);
    } catch {
      if (!this.isConnected || generation !== this._generation) return;
      this._pending = false;
      this._available = false;
      this._render(true);
    }
  }
}

if (!customElements.get('pawl-size-confirmation')) customElements.define('pawl-size-confirmation', PawlSizeConfirmation);
